<template>
  <m-demo-box
    demo-option="demoresidentoccupantlist"
    :hasSaveQuickPick="false"
    :hasTotalRecords="false"
  >
    <b-container fluid>
      <b-row class="demo-box" align-h="center">
        <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
          <div class="card content-box">
          <b-row>
            <b-col class="titlecol">
              <h4>
                Way to go! Now it's time to define your target audience. Use the
                demographic and/or lifestyle options below to select the
                categories and variables of your target audience. Choose as many
                as you like, then select one of the three phone options below.
                That's it! Click "Next" for your count. If you need help, please
                contact a Digital Expert at 800-399-8611.
              </h4>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col><h4>Targeting Options:</h4></b-col>
            <b-col><h4>Route Options:</h4></b-col>
          </b-row>
          <b-row>
            <b-col
              ><b-form-checkbox-group
                plain
                stacked
                v-model="selecttarget"
                :options="targetoption"
            /></b-col>
            <b-col
              ><b-form-checkbox-group
                plain
                stacked
                v-model="selectroute"
                :options="routeoption"
            /></b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col><h4>Contact Names:</h4></b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-check v-model="contactNameOption" value="1" unchecked-value="0"
                >Include contact names where available.</b-check
              >
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <h4>
                * Occupant Lists are addressed to the "Current Resident" or
                "Occupant". Contact names are available upon request for
                approximately 70% of the list by checking the box above. If you
                require a contact name for every record on the list, please
                visit our
                <b-link :to="{ name: 'order', params: { listType: 10 } }">
                  Consumer Lists.</b-link
                >
              </h4>
            </b-col>
          </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </m-demo-box>
</template>

<script>
import MDemoBox from "@/components/demo/MDemoBox";

export default {
  components: {
    MDemoBox,
  },
  data() {
    return {
      targetoption: [
        { value: 1, text: "Include homes" },
        { value: 2, text: "Include apartments" },
        { value: 4, text: "Include businesses" },
      ],
      routeoption: [
        { value: 1, text: "Include Carrier Routes" },
        { value: 2, text: "Include PO Boxes" },
        { value: 4, text: "Include Rural Routes" },
      ],
    };
  },
  computed: {
    contactNameOption: {
      get() {
        return this.$store.getters["order/contactNameOption"];
      },
      set(val) {
        this.$store.commit("order/saveKey", [
          "ContactNameOption",
          parseInt(val),
        ]);
      },
    },
    selecttarget: {
      get() {
        let selected = [];
        let ts = this.$store.getters["order/targetOption"];
        for (let t in this.targetoption) {
          if (
            (ts & this.targetoption[t].value) ===
            this.targetoption[t].value
          ) {
            selected.push(this.targetoption[t].value);
          }
        }
        return selected;
      },
      set(val) {
        let targetoption = 0;
        let values = [];
        for (let v in val) {
          targetoption = targetoption + val[v];
          if (val[v] === 1) {
            values.push({ value: 1, text: "Include homes" });
          } else if (val[v] === 2) {
            values.push({ value: 2, text: "Include apartments" });
          } else {
            values.push({ value: 4, text: "Include businesses" });
          }
        }
        this.$store.commit("order/saveKey", [
          "TargetOption",
          parseInt(targetoption),
        ]);
        this.$store.commit("demo/saveoption", {
          key: "target",
          title: "Targeting Options",
          values: values,
        });
      },
    },
    selectroute: {
      get() {
        let selected = [];
        let ro = this.$store.getters["order/routeOption"];
        for (let t in this.routeoption) {
          if ((ro & this.routeoption[t].value) === this.routeoption[t].value) {
            selected.push(this.routeoption[t].value);
          }
        }
        return selected;
      },
      set(val) {
        let routeoption = 0;
        let values = [];
        for (let v in val) {
          routeoption = routeoption + val[v];
          if (val[v] === 1) {
            values.push({ value: 1, text: "Include Carrier Routes" });
          } else if (val[v] === 2) {
            values.push({ value: 2, text: "Include PO Boxes" });
          } else {
            values.push({ value: 4, text: "Include Rural Routes" });
          }
        }
        this.$store.commit("order/saveKey", ["RouteOption", routeoption]);
        this.$store.commit("demo/saveoption", {
          key: "route",
          title: "Route Options",
          values: values,
        });
      },
    },
  },
  mounted() {
    this.$store.commit("demo/saveoption", {
      key: "target",
      title: "Targeting Options",
      values: this.targetoption,
    });
    this.$store.commit("demo/saveoption", {
      key: "route",
      title: "Route Options",
      values: this.routeoption,
    });
  },
};
</script>

<style scoped lang="scss">
.titlecol {
  margin-top: 10px;
}
.content-box {
  padding: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/DemoResidentOccupantList.vue